export default function hoursToDuration(totalHours: number, colonSeparated?: boolean): string {
    if (!totalHours || totalHours < 0) {
        return colonSeparated ? '0' : '0h';
    }
    const remainingHours = Math.floor(totalHours);
    const remainingMinutes = Math.round((totalHours - remainingHours) * 60);
    const minutesString = remainingMinutes < 10 ? `0${remainingMinutes}` : `${remainingMinutes}`;

    if (colonSeparated) {
            return `${`${remainingHours}:${minutesString}`}`;
    }
    return `${remainingHours ? `${remainingHours}h ` : ''}${remainingMinutes}m`;
}
